import {
  IPaymentBookInfo,
  IPaymentDetailInfo,
} from "./paymentDetailInfo.types";
import { IPaymentInfoType } from "./paymentInfo.types";

export class PaymentDetailInfo implements IPaymentDetailInfo {
  type: IPaymentInfoType;
  payUid: string;
  amount: number;
  updatedAt: string;
  createdAt: string;
  bookInfos: IPaymentBookInfo[];

  constructor(data: IPaymentDetailInfo) {
    this.type = data.type;
    this.payUid = data.payUid;
    this.amount = data.amount;
    this.updatedAt = data.updatedAt;
    this.createdAt = data.createdAt;
    this.bookInfos = data.bookInfos;
  }
}
